(function () {

  console.log('SPI mock store script loaded');

  document.addEventListener('DOMContentLoaded', async () => {

    console.log('DOM ready');

    if (window.__SPI_MOCK_SAVED__) {
      console.log('already saved');
      return;
    }

    if (typeof SPI_STORE === 'undefined') {
      console.error('SPI_STORE not defined');
      return;
    }

    const resultsEl = document.getElementById('spi_results_json');

    if (!resultsEl) {
      console.error('hidden results not found');
      return;
    }

    let results;
    try {
      results = JSON.parse(resultsEl.value || '[]');
    } catch (e) {
      console.error('JSON parse error', e);
      return;
    }

    if (!Array.isArray(results) || results.length === 0) {
      console.error('results empty');
      return;
    }

    const sumEl = document.getElementById('spi_summary_json');
    const metaEl = document.getElementById('spi_meta_json');

    let summary = {};
    let meta = {};

    try {
      summary = JSON.parse(sumEl?.value || '{}');
    } catch (e) {}

    try {
      meta = JSON.parse(metaEl?.value || '{}');
    } catch (e) {}

    window.__SPI_MOCK_SAVED__ = true;

    const fd = new FormData();
    fd.append('action', 'spi_store_mock_attempt');
    fd.append('nonce', SPI_STORE.nonce);
    fd.append('results', JSON.stringify(results));
    fd.append('summary', JSON.stringify(summary));
    fd.append('meta', JSON.stringify(meta));

    try {
      const res = await fetch(SPI_STORE.ajaxurl, {
        method: 'POST',
        body: fd
      });

      const json = await res.json();

      console.log('SAVE RESPONSE:', json);

    } catch (e) {
      console.error('mock store failed', e);
    }

  });

})();
